const getParsedConfiguration = (configuration: string = "{}") => {
    try {
        const parsedConfiguration = JSON.parse(configuration)
        return parsedConfiguration
    }
    catch (error) {
        console.log("Error occured while parsing configuration", error)
        return ({})
    }
}

export default getParsedConfiguration